import React from "react";
import user from "../../../assets/requestDemo/requser.png";
const RequestUser = () => {
  return (
    <div className="bg-[#F5FAFF] py-6 px-4 sm:px-8 md:px-12">
      <div className="flex  flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6 md:gap-10">
        {/* Round CEO Image */}
        <div className="w-[120px] h-[120px] md:w-[120px] md:h-[120px] rounded-full overflow-hidden flex-shrink-0">
          <img
            src={user}
            alt="CEO of Sicunet Inc"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Testimonial Text */}
        <div className="max-w-3xl">
          <p className="text-[22px] md:text-[28px] font-medium text-[#4A4C56] leading-snug md:leading-normal mb-4">
            “Intuitive User Interface is easy to navigate and customizable for
            your clients’ needs.”
          </p>
          <p className="text-[#4A4C56] text-[16px] font-light">
            IKE HUH, CEO of Sicunet
          </p>
        </div>
      </div>
    </div>
  );
};

export default RequestUser;
